<!-- 桌面 -->
<div
    [@slideInLeftOnEnter]
    *ngIf="campaignVisible && !commonService.isMobile"
    class="fixed bottom-4 transition-all duration-300 z-10 text-white overflow-hidden border border-[#EAECED] bg-[rgba(4,4,4,0.86)]"
    [ngClass]="{
       'left-[92px]': sideBarCollapsed,
       'left-[304px]': !sideBarCollapsed,
       'w-14 h-16 rounded-lg': cardCollapsed,
       'w-[435px] h-[200px] rounded-2xl p-5': !cardCollapsed
    }"
>
    <div class="relative w-full h-full">
        <!-- 折叠状态内容 -->
        <div
            class="absolute w-full h-full transition-all duration-300 cursor-pointer"
            [ngClass]="{
                'opacity-100 scale-100 pointer-events-auto z-20': cardCollapsed,
                'opacity-0 scale-95 pointer-events-none z-10': !cardCollapsed
            }"
            (click)="cardCollapsed = false"
        >
            <ng-container *ngTemplateOutlet="collapsedActivityTpl"></ng-container>
        </div>

        <!-- 展开状态内容 -->
        <div
            class="absolute w-full h-full transition-all"
            [ngClass]="{
                'opacity-0 scale-95 pointer-events-none z-10 duration-0': cardCollapsed,
                'opacity-100 scale-100 pointer-events-auto z-20 duration-300 delay-200': !cardCollapsed
            }"
        >
            <ng-container *ngTemplateOutlet="activityTpl"></ng-container>
        </div>
    </div>
</div>

<!-- 移动 -->
<ng-container *ngIf="campaignVisible && commonService.isMobile">
    <div *ngIf="!cardCollapsed" [@fadeInOnEnter] class="w-screen h-screen fixed left-0 top-0 bg-[rgba(4,4,4,0.86)] bg-opacity-50 z-10">
        <div
            class="w-[calc(100%-32px)] bg-black h-[200px] rounded-2xl p-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white overflow-hidden"
        >
            <div class="relative">
                <ng-container *ngTemplateOutlet="activityTpl"></ng-container>
            </div>
        </div>
    </div>

    <div
        *ngIf="cardCollapsed"
        class="fixed left-4 bottom-5 w-14 h-16 rounded-lg z-10 text-white overflow-hidden bg-[rgba(4,4,4,0.86)]"
        [ngClass]="{'left-4 bottom-5': !telegramService.isInTelegramWebApp, 'right-4 bottom-[120px]': telegramService.isInTelegramWebApp}"
        (click)="cardCollapsed = false "
    >
        <ng-container *ngTemplateOutlet="collapsedActivityTpl"></ng-container>
    </div>
</ng-container>

<!-- Collapsed 模板 -->
<ng-template #collapsedActivityTpl>
    <div class="w-full h-full flex-center-center">
        <img src="/assets/imgs/rocket.png" class="w-8 h-8" alt="" />
    </div>
</ng-template>

<!-- 模板 -->
<ng-template #activityTpl>
    <div (click)="$event.stopPropagation()">
        <span
            nz-icon
            nzType="antd:arrow-circle-down"
            class="absolute top-0 right-0 text-sm cursor-pointer"
            (click)="cardCollapsed = !cardCollapsed;$event.stopPropagation()"
        ></span>

        <img src="/assets/imgs/og_booster_banner.png" alt="meme-banner" class="absolute bottom-0 right-0 w-[83px]" />

        <div class="mt-2">
            <div class="text-sm md:text-xl font-semibold leading-[24px]">Claim Your OG Booster</div>

            <div class="text-sm font-light mt-2 leading-[14px] pt-1">Step into the Next Phase: From Miner to MEME Hunter</div>

            <div class="w-9 mt-2 h-[1px] bg-black"></div>

            <div class="flex-start-center mt-3">
                <span class="text-2xs mr-2.5">Ends in </span>

                <ng-container *ngFor="let timeLeftNumber of timeLeftNumbers;let last = last">
                    <div class="time-box">{{timeLeftNumber}}</div>
                    <span *ngIf="!last" class="dot-box">:</span>
                </ng-container>
            </div>

            <button nz-button class="mt-2.5 !rounded !h-[29px] px-2.5 !bg-[linear-gradient(90deg,#C9FFFC_0%,#FFEBA3_100%)]" (click)="joinUs()">
                <span class="text-sm font-bold text-black">Join Now</span>
            </button>
        </div>
    </div>
</ng-template>
